module.exports = __webpack_public_path__ + "img/pattern_withoutbackgr-dark_resized.1756bca5.png";